// eslint-disable-next-line @typescript-eslint/no-empty-interface
import { User, Organization, App, Contact, Resource, WorkSchedule, AvailabilityPeriod } from '@/models'
import { rest } from 'msw'

const apiUrl = process.env.VUE_APP_REVAS_API_URL || '*'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GetUserRequest {
}

interface GetUserResponse {
  user: User;
}

// Organization
interface ListUserOrganizationRequest {
  pageSize: string;
  pageToken: string;
}

interface ListUserOrganizationResponse {
  nextPageToken: string;
  organizations: Organization[];
}

// Launchpad
interface ListPinnedAppsRequest {
  organizationId: string;
  search: string;
  pageSize: number;
  pageToken: string;
}

interface ListPinnedAppsResponse {
  apps: App[];
  nextPageToken: string;
}

// contacts
interface GetContactRequest {
  contactId: string;
}

interface GetContactResponse {
  contact: Contact;
}

interface ListContactsRequest {
  organizationId: string;
  pageSize: number;
  pageToken: string;
  search: string;
}

interface ListContactsResponse {
  contacts: Contact[];
  nextPageToken: string;
}

// Resource
interface GetResourceRequest {
  resourceId: string;
}

interface GetResourceResponse {
  resource: Resource;
}
interface ListResourcesRequest {
  organizationId: string;
  pageSize: number;
  pageToken: string;
  search: string;
}

interface ListResourcesResponse {
  resources: Resource[];
  nextPageToken: string;
}

// Work Schedule
interface CreateWorkScheduleRequest {
  workSchedule: WorkSchedule;
  contactId: string;
}

interface CreateWorkScheduleResponse {
  workSchedule: WorkSchedule;
}

interface GetWorkScheduleRequest {
  workScheduleId: string;
  contactId: string;
}

interface GetWorkScheduleResponse {
  workSchedule: WorkSchedule;
}

interface UpdateWorkScheduleRequest {
  workScheduleId: string;
  workSchedule: WorkSchedule;
  contactId: string;
}

interface UpdateWorkScheduleResponse {
  workSchedule: WorkSchedule;
}

interface DeleteWorkScheduleRequest {
  workScheduleId: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DeleteWorkScheduleResponse {
}

interface ListWorkSchedulesRequest {
  contactId: string;
  organizationId: string;
  pageSize: number;
  pageToken: string;
  search: string;
}

interface ListWorkSchedulesResponse {
  workSchedules: WorkSchedule[];
  nextPageToken: string;
}

interface ApplyPeriodCostCorrectionRequest {
  contactId: string;
  from: string;
  to: string;
  totalPeriodCost: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ApplyPeriodCostCorrectionResponse {
}

// Availability Period
interface CreateAvailabilityPeriodRequest {
  organizationId: string;
  contactId: string;
  availabilityPeriod: AvailabilityPeriod;
}

interface CreateAvailabilityPeriodResponse {
  availabilityPeriod: AvailabilityPeriod;
}

interface GetAvailabilityPeriodRequest {
  organizationId: string;
  contactId: string;
  availabilityPeriodId: string;
}

interface GetAvailabilityPeriodResponse {
  availabilityPeriod: AvailabilityPeriod;
}

interface UpdateAvailabilityPeriodRequest {
  organizationId: string;
  contactId: string;
  availabilityPeriodId: string;
  availabilityPeriod: AvailabilityPeriod;
}

interface UpdateAvailabilityPeriodResponse {
  availabilityPeriod: AvailabilityPeriod;
}

interface ListAvailabilityPeriodsRequest {
  organizationId: string;
  contactId: string;
  pageSize: number;
  pageToken: string;
  search: string;
}

interface ListAvailabilityPeriodsResponse {
  availabilityPeriods: AvailabilityPeriod[];
  nextPageToken: string;
}

interface DeleteAvailabilityPeriodRequest {
  organizationId: string;
  contactId: string;
  availabilityPeriodId: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DeleteAvailabilityPeriodResponse {
}

export const handlers = [
  // system info
  rest.post<any, any>(`${apiUrl}/chaos/chaos.SystemInfo/`, (req, res, ctx) => {
    const body: any = {}
    return res(ctx.delay(500), ctx.json(body))
  }),
  // user
  rest.post<GetUserRequest, GetUserResponse>(`${apiUrl}/users/users.GetUser/`, (req, res, ctx) => {
    const body: GetUserResponse = {
      user: {
        id: '38b36373-9457-4bb9-bd3e-f53432e49a44',
        alias: 'user mock',
        email: 'user.mock@revas.io',
        intercom: '-',
        name: 'user Mock'
      }
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  // organization
  rest.post<ListUserOrganizationRequest, ListUserOrganizationResponse>(`${apiUrl}/organizations/organizations.ListOrganizations/`, (req, res, ctx) => {
    const body: ListUserOrganizationResponse = {
      nextPageToken: '',
      organizations: [
        {
          id: '38b36373-9457-4bb9-bd3e-f53432e49a47',
          name: 'Mock Organization ',
          alias: 'mock-organization',
          email: 'mock-organization@revas.io',
          phone: '123'
        }
      ]
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  // Launchpad
  rest.post<ListPinnedAppsRequest, ListPinnedAppsResponse>(`${apiUrl}/launchpad/launchpad.ListPinnedApps/`, (req, res, ctx) => {
    const body: ListPinnedAppsResponse = {
      nextPageToken: '',
      apps: []
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  //
  //
  // Contact
  rest.post<GetContactRequest, GetContactResponse>(`${apiUrl}/contacts/contacts.GetContact/`, (req, res, ctx) => {
    const contactId = req.body.contactId
    const body: GetContactResponse = {
      contact: {
        id: contactId,
        name: 'Test Contact 1',
        birthDate: '2021-01-01T00:00:00Z',
        birthPlace: '',
        email: '',
        internalCode: '',
        legalAddress: {
          city: '',
          country: '',
          details: '',
          notes: '',
          postalCode: '',
          province: '',
          street: ''
        },
        mailingAddress: {
          city: '',
          country: '',
          details: '',
          notes: '',
          postalCode: '',
          province: '',
          street: ''
        },
        legalEmail: '',
        locked: false,
        metadata: [],
        phone: '',
        taxCode: '',
        type: 'natural',
        groupId: '',
        vatCode: '',
        legalContactId: '',
        memberId: '',
        notes: ''
      }
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<ListContactsRequest, ListContactsResponse>(`${apiUrl}/contacts/contacts.ListContacts/`, (req, res, ctx) => {
    const body: ListContactsResponse = {
      contacts: [
        {
          id: 'test-contact-1',
          name: 'Test Contact 1',
          birthDate: '2021-01-01T00:00:00Z',
          birthPlace: '',
          email: '',
          internalCode: '',
          legalAddress: {
            city: '',
            country: '',
            details: '',
            notes: '',
            postalCode: '',
            province: '',
            street: ''
          },
          mailingAddress: {
            city: '',
            country: '',
            details: '',
            notes: '',
            postalCode: '',
            province: '',
            street: ''
          },
          legalEmail: '',
          locked: false,
          metadata: [],
          phone: '',
          taxCode: '',
          type: 'natural',
          groupId: '',
          vatCode: '',
          legalContactId: '',
          memberId: '',
          notes: ''
        },
        {
          id: 'test-contact-2',
          name: 'Test Contact 2',
          birthDate: '2011-01-01T00:00:00Z',
          birthPlace: '',
          email: '',
          internalCode: '',
          legalAddress: {
            city: '',
            country: '',
            details: '',
            notes: '',
            postalCode: '',
            province: '',
            street: ''
          },
          mailingAddress: {
            city: '',
            country: '',
            details: '',
            notes: '',
            postalCode: '',
            province: '',
            street: ''
          },
          legalEmail: '',
          locked: false,
          metadata: [],
          phone: '',
          taxCode: '',
          type: 'natural',
          groupId: '',
          vatCode: '',
          legalContactId: '',
          memberId: '',
          notes: ''
        }
      ],
      nextPageToken: ''
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  //
  //
  // Resource
  rest.post<GetResourceRequest, GetResourceResponse>(`${apiUrl}/humans/humans.GetResource/`, (req, res, ctx) => {
    const body: GetResourceResponse = {
      resource: {
        id: 'resource-id',
        contactId: 'contact-id',
        organizationId: 'organization-id',
        effectiveFrom: '2022-01-01T00:00:00Z',
        effectiveTo: '2022-03-0T00:00:00Z',
        metadata: [
          {
            key: 'contacts.contact.name',
            value: 'Test Contact 1'
          }
        ]
      }
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<ListResourcesRequest, ListResourcesResponse>(`${apiUrl}/humans/humans.ListResources/`, (req, res, ctx) => {
    const body: ListResourcesResponse = {
      resources: [
        {
          id: 'resource-id-1',
          contactId: 'test-contact-1',
          organizationId: 'organization-id',
          effectiveFrom: '2021-03-22T00:00:00Z',
          effectiveTo: '2051-01-01T00:00:00Z',
          metadata: [
            {
              key: 'contacts.contact.name',
              value: 'Test Contact 1'
            },
            {
              key: 'contacts.contact.email',
              value: 'contact1@example.com'
            },
            {
              key: 'contacts.contact.phone',
              value: '1111'
            }
          ]
        },
        {
          id: 'resource-id-2',
          contactId: 'test-contact-2',
          organizationId: 'organization-id',
          effectiveFrom: '2021-03-22T00:00:00Z',
          effectiveTo: '2051-01-01T00:00:00Z',
          metadata: [
            {
              key: 'contacts.contact.name',
              value: 'Test Contact 2'
            },
            {
              key: 'contacts.contact.email',
              value: 'contact2@example.com'
            },
            {
              key: 'contacts.contact.phone',
              value: '2222'
            }
          ]
        }
      ],
      nextPageToken: ''
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  //
  //
  // Work Schedule
  rest.post<CreateWorkScheduleRequest, CreateWorkScheduleResponse>(`${apiUrl}/humans/humans.CreateWorkSchedule/`, (req, res, ctx) => {
    const body: CreateWorkScheduleResponse = {
      workSchedule: {
        id: 'workschedule-id',
        organizationId: 'organization-id',
        contactId: 'contact-id',
        effectiveFrom: '2022-01-01T00:00:00Z',
        effectiveTo: '2022-01-01T00:00:00Z',
        hourlyCost: 3700,
        hourlyPrice: 5000,
        weeklyDurations: [0, 28800, 28800, 28800, 28800, 28800, 0],
        notes: ''
      }
    }
    if (req.body.workSchedule.id === '') {
      body.workSchedule.id = 'new-work-schedule-id'
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<GetWorkScheduleRequest, GetWorkScheduleResponse>(`${apiUrl}/humans/humans.GetWorkSchedule/`, (req, res, ctx) => {
    const body: GetWorkScheduleResponse = {
      workSchedule: {
        id: 'workschedule-id',
        organizationId: 'organization-id',
        contactId: 'contact-id',
        effectiveFrom: '2022-01-01T00:00:00Z',
        effectiveTo: '2022-01-01T00:00:00Z',
        hourlyCost: 3700,
        hourlyPrice: 5000,
        weeklyDurations: [0, 28800, 28800, 28800, 28800, 28800, 0],
        notes: '',
        metadata: [
          {
            key: 'contacts.contact.name',
            value: 'Test Contact 1'
          }
        ]
      }
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<UpdateWorkScheduleRequest, UpdateWorkScheduleResponse>(`${apiUrl}/humans/humans.UpdateWorkSchedule/`, (req, res, ctx) => {
    const body: UpdateWorkScheduleResponse = {
      workSchedule: req.body.workSchedule
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<DeleteWorkScheduleRequest, DeleteWorkScheduleResponse>(`${apiUrl}/humans/humans.DeleteWorkSchedule/`, (req, res, ctx) => {
    return res(ctx.delay(0), ctx.json({}))
  }),
  rest.post<ListWorkSchedulesRequest, ListWorkSchedulesResponse>(`${apiUrl}/humans/humans.ListWorkSchedules/`, (req, res, ctx) => {
    const body: ListWorkSchedulesResponse = {
      workSchedules: [
        {
          id: 'workschedule-id-1',
          organizationId: 'organization-id',
          contactId: 'contact-id',
          effectiveFrom: '2022-01-01T00:00:00Z',
          effectiveTo: '2022-01-01T00:00:00Z',
          hourlyCost: 3700,
          hourlyPrice: 5000,
          weeklyDurations: [0, 28800, 28800, 28800, 28800, 28800, 0],
          notes: ''
        },
        {
          id: 'workschedule-id-2',
          organizationId: 'organization-id',
          contactId: 'contact-id',
          effectiveFrom: '2022-01-01T00:00:00Z',
          effectiveTo: '2022-01-01T00:00:00Z',
          hourlyCost: 3700,
          hourlyPrice: 5000,
          weeklyDurations: [0, 28800, 28800, 28800, 28800, 28800, 0],
          notes: ''
        }
      ],
      nextPageToken: ''
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<ApplyPeriodCostCorrectionRequest, ApplyPeriodCostCorrectionResponse>(`${apiUrl}/allocations/allocations.ApplyPeriodCostCorrection/`, (req, res, ctx) => {
    return res(ctx.delay(2000), ctx.json({}))
  }),
  // Availability Period
  rest.post<CreateAvailabilityPeriodRequest, CreateAvailabilityPeriodResponse>(`${apiUrl}/availabilities/availabilities.CreateAvailabilityPeriod/`, (req, res, ctx) => {
    const body: CreateAvailabilityPeriodResponse = {
      availabilityPeriod: {
        id: 'availability-period-id',
        state: 'active',
        organizationId: 'organization-id',
        contactId: 'contact-id',
        effectiveFrom: '2022-01-01T00:00:00Z',
        effectiveTo: '2022-01-01T00:00:00Z',
        totalCost: 0
      }
    }
    if (req.body.availabilityPeriod.id === '') {
      body.availabilityPeriod.id = 'new-availability-period-id'
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<GetAvailabilityPeriodRequest, GetAvailabilityPeriodResponse>(`${apiUrl}/availabilities/availabilities.GetAvailabilityPeriod/`, (req, res, ctx) => {
    const body: GetAvailabilityPeriodResponse = {
      availabilityPeriod: {
        id: 'availability-id',
        state: 'active',
        organizationId: 'organization-id',
        contactId: 'contact-id',
        effectiveFrom: '2022-01-01T00:00:00Z',
        effectiveTo: '2022-01-01T00:00:00Z',
        totalCost: 3700
      }
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<UpdateAvailabilityPeriodRequest, UpdateAvailabilityPeriodResponse>(`${apiUrl}/availabilities/availabilities.UpdateAvailabilityPeriod/`, (req, res, ctx) => {
    const body: UpdateAvailabilityPeriodResponse = {
      availabilityPeriod: req.body.availabilityPeriod
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<DeleteAvailabilityPeriodRequest, DeleteAvailabilityPeriodResponse>(`${apiUrl}/availabilities/availabilities.DeleteAvailabilityPeriod/`, (req, res, ctx) => {
    return res(ctx.delay(0), ctx.json({}))
  }),
  rest.post<ListAvailabilityPeriodsRequest, ListAvailabilityPeriodsResponse>(`${apiUrl}/availabilities/availabilities.ListAvailabilityPeriods`, (req, res, ctx) => {
    const body: ListAvailabilityPeriodsResponse = {
      availabilityPeriods: [
        {
          id: 'availability-period-id-1',
          state: 'active',
          organizationId: 'organization-id',
          contactId: 'contact-id',
          effectiveFrom: '2022-01-01T00:00:00Z',
          effectiveTo: '2022-02-01T00:00:00Z',
          totalCost: 2000
        },
        {
          id: 'availability-period-id-2',
          state: 'active',
          organizationId: 'organization-id',
          contactId: 'contact-id',
          effectiveFrom: '2022-02-01T00:00:00Z',
          effectiveTo: '2022-03-01T00:00:00Z',
          totalCost: 3000
        }
      ],
      nextPageToken: ''
    }
    return res(ctx.delay(0), ctx.json(body))
  })
]
